import React, { useEffect, useState, useRef } from 'react';
import UI_Input_Text from './UI_Input_Text';
import UI_Icon from './UI_Icons';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Divider from './UI_Divider';
import UI_Button from './UI_Button';
import UI_Dropdown_New from './UI_Dropdown_New';

export default function UI_Input_Date({
    id,
    Label_Text,
    onInput,
    onSubmit,
    onKeyDown,
    Value,
    Value_Set_Enable,
    onChange,
    onBlur,
    onClick,
    autoFocus,
    onFocus,
    disabled,
    Classes,
    min,
    max,
    PreventPast,
    Required,
    Mode = "Normal",
    Initial_Today = false
}) {
    const DaysInMonth_Get = (Month, Year) => new Date(Year, Month + 1, 0).getDate();
    const FirstDayOfMonth_Get = (Month, Year) => new Date(Year, Month, 1).getDay();
    const Initial = Value ? new Date(Value) : new Date();
    const [Date_Selected, Date_Selected_Set] = useState(Initial);
    const [Day_Selected, Day_Selected_Set] = useState(1);
    const [Month_Display, Month_Display_Set] = useState(Initial.getMonth());
    const [Year_Display, Year_Display_Set] = useState(Initial.getFullYear());
    const [Flyout_Display, Flyout_Display_Set] = useState(false);
    const [Flyout_Display_Render, Flyout_Display_Render_Set] = useState(false);

    const Today = new Date();
    const Today_Year = Today.getFullYear();
    const Today_Month = Today.getMonth();
    const Today_Date = Today.getDate();

    const Wrapper_Ref = useRef();

    const Month_Names = [
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ];
    const Month_Names_Short = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const Weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const Get_Week_Range = (date) => {
        const Start = new Date(date);
        Start.setDate(date.getDate() - date.getDay());
        const End = new Date(Start);
        End.setDate(Start.getDate() + 6);
        return { Start, End };
    }

    const Get_Week_String = (date) => {
        const Temp = new Date(date.getTime());
        Temp.setHours(0, 0, 0, 0);
        Temp.setDate(Temp.getDate() + 3 - ((Temp.getDay() + 6) % 7));
        const Week_1 = new Date(Temp.getFullYear(), 0, 4);
        const Week_Number = 1 + Math.round(((Temp.getTime() - Week_1.getTime()) / 86400000 - 3 + ((Week_1.getDay() + 6) % 7)) / 7);
        
        return {
            String: `${Format_Date(Get_Week_Range(Date_Selected).Start, "Shortened_NoYear")} - ${Format_Date(Get_Week_Range(Date_Selected).End, "Shortened_NoYear")} (Week ${Week_Number.toString().padStart(2, "0")}) ${Year_Display}`,
            Input_Value: `${Temp.getFullYear()}-W${Week_Number.toString().padStart(2, "0")}`
        };
    }

    const toDateObject = (d) => {
        return (d instanceof Date) ? d : new Date(d);
    }

    const Format_Date = (dateInput, component) => {
        const d = toDateObject(dateInput);
        const weekday = Weekdays[d.getDay()];
        const day = d.getDate();
        const month = Month_Names[d.getMonth()];
        const month_short = Month_Names_Short[d.getMonth()];
        const year = d.getFullYear();
        if (!component) {
            return `${weekday}, ${day} ${month} ${year}`;
        } else if (component === "Month Year") {
            return `${month} ${year}`;
        } else if (component === "Shortened") {
            return `${day} ${month_short} ${year}`;
        } else if (component === "Shortened_NoYear") {
            return `${day} ${month_short}`;
        }
    }

    const Handle_Click = () => {
        Flyout_Display_Set(!Flyout_Display);
        if (onClick) {
            onClick();
        }
    }

    useEffect(() => {
        if (!Flyout_Display) {
            if (id) {
                document.getElementById(id).focus();
            }
            setTimeout(() => {
                Flyout_Display_Render_Set(Flyout_Display);
            }, 200)
        } else {
            Flyout_Display_Render_Set(Flyout_Display);
        }

    }, [Flyout_Display]);

    useEffect(() => {
        const Handle_Outside = (event) => {
            if (Wrapper_Ref.current && !Wrapper_Ref.current.contains(event.target)) {
                Flyout_Display_Set(false);
            }
        };

        document.addEventListener('mousedown', Handle_Outside);

        const Handle_Escape = (e) => {
            if (e.key === "Escape") {
                Flyout_Display_Set(false);
            }
        };
        document.addEventListener('keydown', Handle_Escape);
        return () => {
            document.removeEventListener('mousedown', Handle_Outside);
            document.removeEventListener('keydown', Handle_Escape);
        };
    }, []);

    const Handle_Date_Select = (Day) => {
        const Date_New = new Date(Year_Display, Month_Display, Day);

        if (PreventPast) {
            const Today_DateOnly = new Date(Today_Year, Today_Month, Today_Date);
            if (Date_New < Today_DateOnly) {
                return;
            }
        }

        if (Mode === "Week") {
            const Week_Range = Get_Week_Range(Date_New);
            Date_Selected_Set(Week_Range.Start);
            Day_Selected_Set(Week_Range.Start.getDate());
        } else {
            Date_Selected_Set(Date_New);
            Day_Selected_Set(Day);
        }

        // Date_Selected_Set(Date_New);
        // Day_Selected_Set(Day);
    }

    const Handle_Month_Navigate = (Direction) => {
        let NewMonth = Month_Display;
        let NewYear = Year_Display;

        if (Direction === "Previous") {
            if (NewMonth === 0) {
                NewMonth = 11;
                NewYear -= 1;
            } else {
                NewMonth -= 1;
            }
        } else if (Direction === "Next") {
            if (NewMonth === 11) {
                NewMonth = 0;
                NewYear += 1;
            } else {
                NewMonth += 1;
            }
        }

        // Prevent navigating to a month entirely in the past
        if (PreventPast) {
            const LastDayOfNewMonth = new Date(NewYear, NewMonth, DaysInMonth_Get(NewMonth, NewYear));
            const Today_DateOnly = new Date(Today_Year, Today_Month, Today_Date);
            if (LastDayOfNewMonth < Today_DateOnly) return;
        }

        Month_Display_Set(NewMonth);
        Year_Display_Set(NewYear);
    };

    const Handle_Change = (Target, Value) => {
        if (Target === "Month") {
            // console.log("Month");
            // console.log(Value);
            const Index = Value;
            if (Index >= 0) {
                Month_Display_Set(Index);
            }
        }
        if (Target === "Year") {
            const Value_New = parseInt(Value);
            if (!isNaN(Value_New)) {
                Year_Display_Set(Value_New);
            }
        }
    }

    const Render_Days = () => {
        const Days = [];
        const Days_Total = DaysInMonth_Get(Month_Display, Year_Display);
        const Day_First = FirstDayOfMonth_Get(Month_Display, Year_Display);
        const Days_PreviousMonth = DaysInMonth_Get(Month_Display - 1 < 0 ? 11 : Month_Display - 1, Month_Display - 1 < 0 ? Year_Display - 1 : Year_Display);

        const Week_Range_Active = Mode === "Week" ? Get_Week_Range(Date_Selected) : null;
        for (let a = 0; a < Day_First; a++) {
            const DateCheck = new Date(Year_Display, Month_Display, a);
            const isPast =
                PreventPast &&
                DateCheck < new Date(Today_Year, Today_Month, Today_Date);
            Days.push(
                <button
                    key={`Previous-${a}`}
                    className='Input_Date_Flyout_Input_Grid_Day'
                    State="Faded"
                    type='button'
                    onClick={() => {
                        Handle_Date_Select(Days_PreviousMonth - Day_First + a + 1);
                        Handle_Month_Navigate("Previous");
                    }}
                    disabled={isPast}
                >
                    {Days_PreviousMonth - Day_First + a + 1}
                </button>
            )
        }
        for (let a = 1; a <= Days_Total; a++) {
            const DateCheck = new Date(Year_Display, Month_Display, a);
            const isPast =
                PreventPast &&
                DateCheck < new Date(Today_Year, Today_Month, Today_Date);
            let isSelected = false;
            if (Mode === "Week" && Week_Range_Active) {
                isSelected = DateCheck >= Week_Range_Active.Start && DateCheck <= Week_Range_Active.End;
            } else {
                isSelected =
                    Date_Selected.getDate() === a &&
                    Date_Selected.getMonth() === Month_Display &&
                    Date_Selected.getFullYear() === Year_Display;
            }
            
            Days.push(
                <button
                    key={`Day-${a}`}
                    className='Input_Date_Flyout_Input_Grid_Day'
                    State={isSelected ? "Active" : isPast ? "Faded" : "Inactive"}
                    type='button'
                    onClick={() => !isPast && Handle_Date_Select(a)}
                    disabled={isPast}
                >
                    {a}
                </button>
            )
        }

        while (Days.length < 42) {
            const Day_Next = Days.length - (Day_First + Days_Total) + 1;
            Days.push(
                <button
                    key={`Next-${Day_Next}`}
                    className='Input_Date_Flyout_Input_Grid_Day'
                    State="Faded"
                    type='button'
                    onClick={() => {
                        Handle_Date_Select(Day_Next);
                        Handle_Month_Navigate("Next");
                    }}
                >
                    {Day_Next}
                </button>
            )
        }
        return Days;
    }

    const Handle_Today = () => {
        const Today = new Date();
        Date_Selected_Set(Today);
        Month_Display_Set(Today.getMonth());
        Year_Display_Set(Today.getFullYear());
    }

    const [Display_Formatted, Display_Formatted_Set] = useState("");
    const [Value_Hidden, Value_Hidden_Set] = useState("");

    

    // useEffect(() => {
    //     if (Flyout_Display_Render) {
    //         document.getElementById(`${id}_Input_Hours`).select();
    //     }
    // }, [Flyout_Display_Render]);

    // useEffect(() => {
    //     const DaysInNewMonth = DaysInMonth_Get(Month_Display, Year_Display);
    //     const NewDay = Math.min(Day_Selected, DaysInNewMonth);

    //     const NewDate = new Date(Year_Display, Month_Display, NewDay);
    //     Date_Selected_Set(NewDate);
    //     Day_Selected_Set(NewDay);
    // }, [Month_Display, Year_Display]);
    useEffect(() => {
        const DaysInNewMonth = DaysInMonth_Get(Month_Display, Year_Display);
        let NewDay = Math.min(Day_Selected, DaysInNewMonth);

        if (PreventPast) {
            const Today_DateOnly = new Date(Today_Year, Today_Month, Today_Date);
            const FirstDayOfMonth = new Date(Year_Display, Month_Display, 1);

            if (FirstDayOfMonth < Today_DateOnly) {
                Month_Display_Set(Today_Month);
                Year_Display_Set(Today_Year);
                return;
            }

            if (Year_Display === Today_Year && Month_Display === Today_Month) {
                NewDay = Math.max(NewDay, Today_Date);
            }
        }

        const NewDate = new Date(Year_Display, Month_Display, NewDay);
        Date_Selected_Set(NewDate);
        Day_Selected_Set(NewDay);
    }, [Month_Display, Year_Display]);

    useEffect(() => {
        let formatted = "";
        let valueHidden = "";

        if (Mode === "Week") {
            const weekInfo = Get_Week_String(Date_Selected);
            formatted = weekInfo.String;
            valueHidden = weekInfo.Input_Value;
        } else if (Mode === "Month") {
            formatted = `${Month_Names[Month_Display]} ${Year_Display}`;
            valueHidden = `${Year_Display}-${(Month_Display + 1).toString().padStart(2, "0")}`;
        } else {
            formatted = Format_Date(Date_Selected);
            // valueHidden = Date_Selected.toISOString().split('T')[0];
            valueHidden = [
                Date_Selected.getFullYear(),
                String(Date_Selected.getMonth() + 1).padStart(2, "0"),
                String(Date_Selected.getDate()).padStart(2, "0")
            ].join("-");
        }

        Display_Formatted_Set(formatted);
        Value_Hidden_Set(valueHidden);
    }, [Date_Selected, Month_Display, Year_Display, Mode]);

    // --- Effect: Emit onChange whenever display/value updates
    useEffect(() => {
        if (onChange && id && Value_Hidden !== "") {
            onChange({
                target: {
                    id: id,
                    value: Value_Hidden,
                    display: Display_Formatted
                }
            });
        }
    }, [Display_Formatted, Value_Hidden]);
    

    useEffect(() => {
        if (Initial_Today) {
            Handle_Today();
        }
    }, [Initial_Today])
    return (
        <>
            {Mode === "Normal" ?
                <input
                    type="date"
                    id={`${id}_Input_Raw`}
                    value={Value_Hidden}
                    readOnly
                    hidden
                />
                :
                Mode === "Week" ?
                    <input
                        type="week"
                        id={`${id}_Input_Raw`}
                        value={Value_Hidden}
                        readOnly
                        hidden
                    />
                    :
                    Mode === "Month" ?
                        <input
                            type="month"
                            id={`${id}_Input_Raw`}
                            value={Value_Hidden}
                            readOnly
                            hidden
                        />
                        :
                        ""
            }
            
            {Label_Text ? (
                <label className="Input_Label" htmlFor={id}>
                    {Label_Text}{Required ? <p className="Input_Label_Required">*</p> : ""}
                </label>
            ) : null}
            <div className='Input_Time_Wrapper' ref={Wrapper_Ref}>
                <button
                    className='Input_Text Input_Time'
                    id={id}
                    onClick={Handle_Click}
                    type='button'
                    Date={Display_Formatted}
                >
                    <p className='General_Paragraph Input_Time_Text'>
                        {Display_Formatted}
                    </p>
                    <UI_Icon
                        className="Input_Icon"
                        Name="Calendar"
                    />
                </button>
                <p className="Input_Text_Prompt" id={`${id}_Prompt`}></p>
                {Flyout_Display_Render ?
                    <div
                        className='Input_Time_Flyout Input_Date_Flyout'
                        State={Flyout_Display ? "Active" : "Inactive"}

                    >
                        <p className='General_Paragraph'>
                            Select {Mode === "Week" ? "week" : Mode === "Month" ? "month" : "date"}
                        </p>
                        <div className="Input_Date_Flyout_Header">
                            <div className="Input_Date_Flyout_Input">
                                <UI_Dropdown_New
                                    className="Input_Date_Flyout_Input_Component"
                                    id={`${id}_Input_Dropdown_Months`}
                                    Items={Month_Names.map((m) => ({ Name: m }))}
                                    Selected={{ Name: Month_Names[Month_Display] }}
                                    onSelect={(Item, Index) => {
                                        Month_Display_Set(Index);
                                    }}
                                />
                                <input
                                    type="number"
                                    className="Input_Text Input_Date_Flyout_Input_Component"
                                    value={Year_Display}
                                    onChange={(e) => Handle_Change("Year", e.target.value)}
                                />
                            </div>
                            {Mode !== "Month" ? 
                                <>
                                    <UI_Button
                                        className="Input_Time_Flyout_Button"
                                        OnClick={() => Handle_Month_Navigate('Previous')}
                                        Type="button"
                                        Icon={<UI_Icon Name="Arrow_Left" />}
                                        Icon_Position="Center"
                                    />
                                    <UI_Button
                                        className="Input_Time_Flyout_Button"
                                        OnClick={() => Handle_Month_Navigate('Next')}
                                        Type="button"
                                        Icon={<UI_Icon Name="Arrow_Right" />}
                                        Icon_Position="Center"
                                    />
                                </>
                                :
                                ""
                            }
                            
                        </div>
                        {Mode !== "Month" ?
                            <div className="Input_Date_Flyout_Input_Grid">
                                {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((d) => (
                                    <div key={d} className="Input_Date_Flyout_Input_Grid_Day" Type="Header">{d}</div>
                                ))}
                                {Render_Days()}
                            </div>
                            :
                            ""
                        }
                        
                        <div style={{display: "grid", gridTemplateColumns: "0.5fr 1fr", gap: "5px"}}>
                            <UI_Button
                                Text="Today"
                                className="Input_Time_Flyout_Button"
                                OnClick={Handle_Today}
                                Type="button"
                            />
                            <UI_Button
                                Text="OK"
                                Fill={true}
                                className="Input_Time_Flyout_Button"
                                OnClick={Handle_Click}
                                Type="button"
                            />
                        </div>

                    </div>
                    :
                    ""
                }

            </div>


        </>
    )
}